/* Meaningwave hub sections (mw-hub-articles, mw-hub-videos).
   Fetches sections/mw-hub-feed.liquid rendered on a tagged blog URL and fills the page. */
(function () {
  if (window.MWHub) return;

  var feeds = {};
  var YT_ID = /^[A-Za-z0-9_-]{11}$/;

  function getFeed(url) {
    if (!feeds[url]) {
      feeds[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Feed ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('.mw-hub-card'));
        });
      feeds[url].catch(function () { delete feeds[url]; });
    }
    return feeds[url];
  }

  function hasTag(card, tag) {
    if (!tag) return true;
    return (' ' + (card.getAttribute('data-tags') || '') + ' ').indexOf(' ' + tag + ' ') > -1;
  }

  function status(target, text) {
    target.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'mw-hub-status';
    p.textContent = text;
    target.appendChild(p);
  }

  function initArticles(root) {
    var target = root.querySelector('[data-mw-target]');
    var more = root.querySelector('[data-mw-more]');
    var initial = parseInt(root.getAttribute('data-initial'), 10) || 8;

    getFeed(root.getAttribute('data-feed')).then(function (cards) {
      target.innerHTML = '';
      if (!cards.length) { status(target, 'Nothing here yet.'); return; }
      cards.forEach(function (card, i) {
        var node = document.importNode(card, true);
        if (i >= initial) node.hidden = true;
        target.appendChild(node);
      });
      if (more && cards.length > initial) {
        more.hidden = false;
        more.addEventListener('click', function () {
          var hidden = target.querySelectorAll('.mw-hub-card[hidden]');
          for (var i = 0; i < hidden.length && i < initial; i++) hidden[i].hidden = false;
          if (!target.querySelector('.mw-hub-card[hidden]')) more.hidden = true;
        });
      }
    }).catch(function () {
      status(target, 'Could not load posts. Use the View all button below.');
    });
  }

  function hasAny(card, tags) {
    for (var i = 0; i < tags.length; i++) if (hasTag(card, tags[i])) return true;
    return false;
  }

  /* Short label for the strip: drop "| Music Video | Meaningwave…", "Artist - " prefixes and "with Scott Adams…" tails. */
  function esc(r) { return r.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function cleanTitle(t, name) {
    var c = t.replace(/\s*\|.*$/, '');
    if (name) {
      var n = esc(name);
      c = c
        .replace(new RegExp('^(Akira The Don\\s*(&|ft\\.?|x)\\s*' + n + '|' + n + '\\s*(&|x)\\s*Akira The Don|Akira The Don|' + n + ')\\s*-\\s*', 'i'), '')
        .replace(new RegExp('\\s+(with|ft\\.?|feat\\.?)\\s+' + n + '\\b.*$', 'i'), '');
    } else {
      c = c.replace(/^Akira The Don\s*-\s*/i, '');
    }
    c = c.replace(/\s*Music Video\s*$/i, '').trim();
    return c || t;
  }
  function shortDate(d) {
    var x = new Date(d);
    return isNaN(x) ? '' : x.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function player(p, count, captions, autoplay) {
    var col = document.createElement('div');
    col.className = 'block_video position-relative ' + (count > 1 ? 'col-lg-6' : 'col-12');
    var wrap = document.createElement('div');
    wrap.className = 'embed-responsive embed-responsive-16by9';
    var iframe = document.createElement('iframe');
    iframe.className = 'embed-responsive-item';
    iframe.src = 'https://www.youtube.com/embed/' + p.id + '?rel=0' + (autoplay ? '&autoplay=1' : '');
    iframe.title = p.title || 'Music video';
    if (!autoplay) iframe.loading = 'lazy';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    wrap.appendChild(iframe);
    col.appendChild(wrap);
    if (captions && p.title) {
      var cap = document.createElement('div');
      cap.className = 'mw-hub-video__caption';
      var a = document.createElement('a');
      a.href = p.url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = p.title;
      cap.appendChild(a);
      col.appendChild(cap);
    }
    return col;
  }

  /* YouTube Data API (optional): read a playlist directly. Public videos only (unlisted/private skipped). Cached per visitor for 3 hours. */
  function ytPlaylist(key, list, maxPages) {
    maxPages = maxPages || 6;
    var ck = 'mwyt2:' + maxPages + ':' + list, now = Date.now();
    try {
      var c = JSON.parse(localStorage.getItem(ck) || 'null');
      if (c && now - c.t < 3 * 36e5 && c.items && c.items.length) return Promise.resolve(c.items);
    } catch (e) {}
    var out = [];
    function page(token, n) {
      var u = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet,contentDetails,status&maxResults=50&playlistId=' +
        encodeURIComponent(list) + '&key=' + encodeURIComponent(key) + (token ? '&pageToken=' + token : '');
      return fetch(u).then(function (r) {
        if (!r.ok) throw new Error('YouTube ' + r.status);
        return r.json();
      }).then(function (j) {
        (j.items || []).forEach(function (it) {
          var sn = it.snippet || {}, cd = it.contentDetails || {}, st = it.status || {};
          if (st.privacyStatus && st.privacyStatus !== 'public') return; /* skip unlisted / private */
          var id = cd.videoId || (sn.resourceId && sn.resourceId.videoId);
          if (!id || !YT_ID.test(id) || /^(Private|Deleted) video$/.test(sn.title || '')) return;
          out.push({ id: id, title: sn.title || '', url: 'https://www.youtube.com/watch?v=' + id, date: cd.videoPublishedAt || sn.publishedAt || '' });
        });
        if (j.nextPageToken && n < maxPages) return page(j.nextPageToken, n + 1);
      });
    }
    return page('', 1).then(function () {
      out.sort(function (a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; });
      try { localStorage.setItem(ck, JSON.stringify({ t: now, items: out })); } catch (e) {}
      return out;
    });
  }

  function tagList(root, attr) {
    return (root.getAttribute(attr) || '').split(' ').filter(Boolean);
  }

  function initVideos(root) {
    var target = root.querySelector('[data-mw-target]');
    var count = parseInt(root.getAttribute('data-count'), 10) || 1;
    var videoTag = root.getAttribute('data-video-tag') || '';
    var excludeTag = root.getAttribute('data-exclude-tag') || '';
    var tabTags = [null, tagList(root, 'data-tab2-tags'), tagList(root, 'data-tab3-tags')];
    var captions = root.getAttribute('data-captions') === 'true';
    var strip = root.querySelector('[data-mw-strip]');
    var ytKey = root.getAttribute('data-yt-key') || '';
    var ytPages = parseInt(root.getAttribute('data-yt-pages'), 10) || 6;
    var stripName = root.hasAttribute('data-strip-name') ? root.getAttribute('data-strip-name') : 'Scott Adams';
    root._mwStripName = stripName;
    var ytLists = [root.getAttribute('data-yt-list') || '', root.getAttribute('data-yt-list2') || '', root.getAttribute('data-yt-list3') || ''];

    var blog = null;
    function fromBlog(i) {
      if (!blog) blog = getFeed(root.getAttribute('data-feed'));
      return blog.then(function (cards) {
        var test = i === 0
          ? function (c) { return hasTag(c, videoTag) && !(excludeTag && hasTag(c, excludeTag)); }
          : function (c) { return tabTags[i].length && hasAny(c, tabTags[i]); };
        var seen = {}, out = [];
        cards.forEach(function (card) {
          var id = card.getAttribute('data-yt');
          if (!id || !YT_ID.test(id) || seen[id] || !test(card)) return;
          seen[id] = true;
          out.push({ id: id, title: card.getAttribute('data-title') || '', url: card.getAttribute('data-url') || '' });
        });
        return out;
      });
    }
    function source(i) {
      if (ytKey && ytLists[i]) return ytPlaylist(ytKey, ytLists[i], ytPages).catch(function () { return fromBlog(i); });
      return fromBlog(i);
    }

    Promise.all([
      source(0),
      source(1).catch(function () { return []; }),
      source(2).catch(function () { return []; })
    ]).then(function (lists) {
      var picks = lists[0].slice(0, count);
      if (!picks.length) { root.closest('.mw-hub-videos').hidden = true; return; }

      target.innerHTML = '';
      picks.forEach(function (p) { target.appendChild(player(p, count, captions, false)); });

      if (strip) buildStrip(root, strip, target, lists, count, captions, picks[0].id);
    }).catch(function () {
      root.closest('.mw-hub-videos').hidden = true;
    });
  }

  function buildStrip(root, strip, target, lists, count, captions, playingId) {
    var menu = strip.querySelector('[data-mw-menu]');
    var tabs = strip.querySelectorAll('[data-mw-tab]');
    var current = -1;

    var total = lists.reduce(function (n, l) { return n + l.length; }, 0);
    if (total <= 1) { strip.hidden = true; return; }
    tabs.forEach(function (t) {
      var i = +t.getAttribute('data-mw-tab');
      var has = lists[i] && lists[i].length > 0;
      if (i > 0) t.hidden = !has;
      if (has && current < 0) current = i;
    });
    if (current < 0) current = 0;

    function render() {
      menu.innerHTML = '';
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(+t.getAttribute('data-mw-tab') === current)); });
      var name = root._mwStripName, seen = {};
      (lists[current] || []).forEach(function (p) { var l = cleanTitle(p.title, name); seen[l] = (seen[l] || 0) + 1; });
      (lists[current] || []).forEach(function (p) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mw-hub-videos__item' + (p.id === playingId ? ' is-playing' : '');
        var thumb = document.createElement('span');
        thumb.className = 'mw-hub-videos__thumb';
        var img = document.createElement('img');
        img.src = 'https://i.ytimg.com/vi/' + p.id + '/mqdefault.jpg';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 320; img.height = 180;
        thumb.appendChild(img);
        var label = document.createElement('span');
        label.className = 'mw-hub-videos__label';
        var lt = cleanTitle(p.title, name);
        label.textContent = seen[lt] > 1 && p.date ? lt.replace(/^\W+/, '') + ' · ' + shortDate(p.date) : lt;
        btn.appendChild(thumb);
        btn.appendChild(label);
        btn.addEventListener('click', function () {
          playingId = p.id;
          var first = target.querySelector('.block_video');
          var fresh = player(p, count, captions, true);
          if (first) target.replaceChild(fresh, first); else target.appendChild(fresh);
          menu.querySelectorAll('.is-playing').forEach(function (b) { b.classList.remove('is-playing'); });
          btn.classList.add('is-playing');
          var top = target.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * 0.6) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        li.appendChild(btn);
        menu.appendChild(li);
      });
      menu.scrollLeft = 0;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        current = +t.getAttribute('data-mw-tab');
        render();
      });
    });
    strip.querySelectorAll('[data-mw-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        menu.scrollBy({ left: +b.getAttribute('data-mw-scroll') * menu.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    render();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mw-hub-articles]:not([data-mw-ready])').forEach(function (el) {
      el.setAttribute('data-mw-ready', '');
      initArticles(el);
    });
    scope.querySelectorAll('[data-mw-hub-videos]:not([data-mw-ready])').forEach(function (el) {
      el.setAttribute('data-mw-ready', '');
      initVideos(el);
    });
  }

  window.MWHub = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
